<ng-container *ngIf="isLoading">
  <app-loader></app-loader>
</ng-container>

<div class="modal-header">
  <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
    Close
  </button>
  <h4 class="modal-title text-center" id="modal-title">
    {{ !storeId ? 'Create New Store' : 'Edit Store' }}
  </h4>
</div>
<div class="modal-body">
  <form name="storeForm" #storeForm="ngForm">
    <div class="form-row justify-content-center">
      <div class="col-10">
        <div class="form-group">
          <label for="name">Name*</label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            placeholder="Name"
            autocomplete="off"
            [(ngModel)]="store.name"
            required
            maxlength="100"
          />
        </div>

        <div class="form-group">
          <label for="url">Store Url*</label>
          <input
            type="text"
            class="form-control"
            id="url"
            name="url"
            placeholder="Store Url"
            autocomplete="off"
            [(ngModel)]="internalUrl"
            required
            #url="ngModel"
            maxlength="100"
          />
          @if(url.errors?.duplicate){
          <div class="invalid-feedback">Url already in use</div>
          }
        </div>

        <div class="form-group">
          <label for="storeType">Store Type*</label>
          <ng-select
            id="storeType"
            name="Store Type"
            placeholder="Store Type"
            [items]="storeTypesOptions"
            bindLabel="name"
            [(ngModel)]="store.storeType"
            autocomplete="off"
            required
            [clearable]="false"
            [style.position]="'relative'"
          >
          </ng-select>
        </div>

        <div class="form-group">
          <label for="StoreCurrency">Store Currency*</label>
          <ng-select
            id="StoreCurrency"
            name="Store Currency"
            placeholder="Store Currency"
            [items]="currencies"
            bindLabel="code"
            [(ngModel)]="currency"
            autocomplete="off"
            required
            [clearable]="false"
            [style.position]="'relative'"
          >
          </ng-select>
        </div>

        <div class="form-group">
          <label for="paymentSupplier">Payment Supplier*</label>
          <ng-select
            id="paymentSupplier"
            name="paymentSupplier"
            placeholder="Payment Supplier"
            [items]="paymentSuppliers"
            bindLabel="name"
            bindValue="value"
            [(ngModel)]="store.paymentSupplier"
            autocomplete="off"
            required
            [clearable]="false"
          >
          </ng-select>
        </div>

        <div class="form-group">
          <label for="External">Store Website Url*</label>
          <input
            type="url"
            class="form-control"
            id="External"
            name="External"
            placeholder="https://"
            autocomplete="on"
            [(ngModel)]="integration.websiteUrl"
            maxlength="100"
            required
          />
        </div>
        <div class="form-group">
          <label for="cartPath">Store Checkout Path</label>
          <input
            type="url"
            class="form-control"
            id="cartPath"
            name="cartPath"
            placeholder="checkout/cart"
            autocomplete="on"
            [(ngModel)]="integration.cartPath"
            maxlength="100"
          />
        </div>

        <div class="form-group">
          <label for="integrationClass">Integration Class*</label>
          <ng-select
            id="integrationClass"
            name="Integration Class*"
            [(ngModel)]="integration.integrationClass"
            autocomplete="off"
            [clearable]="false"
            required
          >
            <ng-option value="BaseGeneric">BaseGeneric</ng-option>
            <ng-option value="FloweryCustom">FloweryCustom</ng-option>
            <ng-option value="PanecoCustom">PanecoCustom</ng-option>
            <ng-option value="PimkieCustom">PimkieCustom</ng-option>
            <ng-option value="RapourCustom">RapourCustom</ng-option>
          </ng-select>
        </div>

        <div class="form-group">
          <label for="ClearCartPolicy">Cart clear policy</label>
          <ng-select
            id="ClearCartPolicy"
            name="Clear Cart Policy"
            [(ngModel)]="cartClearPolicy"
            autocomplete="off"
            [clearable]="false"
          >
            <ng-option *ngFor="let item of cartClearPolicyList | keyvalue" [value]="item.key">{{
              item.value
            }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group">
          <label for="ManagementPolicy">Stock Management policy</label>
          <ng-select
            id="ManagementPolicy"
            name="Management policy"
            [(ngModel)]="stockManagementPolicy"
            autocomplete="off"
            [clearable]="false"
          >
            <ng-option *ngFor="let item of managementListPolicy | keyvalue" [value]="item.key">{{
              item.value
            }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group">
          <label for="broadcastResolution">Broadcast Resolution</label>
          <ng-select
            id="broadcastResolution"
            name="Broadcast resolution"
            [(ngModel)]="broadcastResolution"
            autocomplete="off"
            [clearable]="false"
          >
            @for (item of broadcastResolutionSelect | keyvalue; track item.key) {
            <ng-option [value]="item.key">{{ item.value }}</ng-option>
            }
          </ng-select>
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="haveTheme"
              name="haveTheme"
              [(ngModel)]="haveTheme"
            />
            <label class="custom-control-label" for="haveTheme">Have Theme</label>
          </div>
        </div>
        <div *ngIf="haveTheme" class="form-group">
          <label for="primary">Primary Color</label>
          <input
            type="color"
            class="form-control"
            id="primary"
            name="primary"
            placeholder="Store primary color"
            autocomplete="off"
            [(ngModel)]="theme.primaryColor"
          />
        </div>

        <div *ngIf="haveTheme" class="form-group">
          <label for="secondary">Secondary Color</label>
          <input
            type="color"
            class="form-control"
            id="secondary"
            name="secondary"
            placeholder="Store secondary color"
            autocomplete="off"
            [(ngModel)]="theme.secondaryColor"
          />
        </div>

        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="isPublished"
              name="isPublished"
              [(ngModel)]="store.isPublished"
            />
            <label class="custom-control-label" for="isPublished">Is Published</label>
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="hostVideoGrid"
              name="hostVideoGrid"
              [(ngModel)]="store.hostVideoGrid"
            />
            <label class="custom-control-label" for="hostVideoGrid">Host Video Grid</label>
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="pictureInPicture"
              name="pictureInPicture"
              [(ngModel)]="pictureInPicture"
            />
            <label class="custom-control-label" for="pictureInPicture">Picture in picture</label>
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mirrorHost"
              name="mirrorHost"
              [(ngModel)]="mirrorHost"
            />
            <label class="custom-control-label" for="mirrorHost">Mirror host</label>
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="isAutoCheckoutEnabled"
              name="isAutoCheckoutEnabled"
              [(ngModel)]="store.isAutoCheckoutEnabled"
            />
            <label class="custom-control-label" for="isAutoCheckoutEnabled">Auto Checkout</label>
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="embedPostSession"
              name="embedPostSession"
              [(ngModel)]="embedPostSession"
            />
            <label class="custom-control-label" for="embedPostSession">Embed Post Session</label>
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="externalCart"
              name="externalCart"
              [(ngModel)]="store.externalCart"
            />
            <label class="custom-control-label" for="externalCart">External Cart</label>
          </div>
        </div>
        @if(store.id&&storesIdsThatSupportColorPalate.includes(store.id)){
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="colorPalateSelector"
              name="colorPalateSelector"
              [(ngModel)]="store.colorPalateSelector"
            />
            <label class="custom-control-label" for="colorPalateSelector">
              Support the color palette
            </label>
          </div>
        </div>
        }
        <div class="form-group">
          <label class="custom-control" for="embedPreSessionTimeFrame"
            >Hours Before Live Session to Embed</label
          >
          <div class="custom-control">
            <input
              type="number"
              class="form-control"
              id="embedPreSessionTimeFrame"
              name="embedPreSessionTimeFrame"
              placeholder="24"
              autocomplete="off"
              [(ngModel)]="embedPreSessionTimeFrame"
            />
          </div>
        </div>

        <div class="mb-4 mt-4">
          <button class="btn btn-yellow w-132 mb-4" (click)="showMoreSettings = !showMoreSettings">
            {{ showMoreSettings ? 'Hide Settings' : 'More Settings' }}
          </button>

          <div *ngIf="showMoreSettings">
            <div class="form-group">
              <label for="productCatalogUrl">Product Catalog URL</label>
              <input
                type="text"
                class="form-control"
                id="productCatalogUrl"
                name="productCatalogUrl"
                placeholder="https://"
                autocomplete="off"
                [(ngModel)]="integration.productCatalogUrl"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label for="apiUrl">API URL</label>
              <input
                type="text"
                class="form-control"
                id="apiUrl"
                name="apiUrl"
                placeholder="https://"
                autocomplete="off"
                [(ngModel)]="integration.apiUrl"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label for="apiToken">API token</label>
              <input
                type="text"
                class="form-control"
                id="apiToken"
                name="apiToken"
                placeholder="Bearer "
                autocomplete="off"
                [(ngModel)]="integration.apiToken"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label for="productUniqueIdFieldName">Product ID field name</label>
              <input
                type="text"
                class="form-control"
                id="productUniqueIdFieldName"
                name="productUniqueIdFieldName"
                placeholder="Bearer "
                autocomplete="off"
                [(ngModel)]="integration.productUniqueIdFieldName"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label for="productVariantUniqueIdFieldName">Product variant ID field name</label>
              <input
                type="text"
                class="form-control"
                id="productVariantUniqueIdFieldName"
                name="productVariantUniqueIdFieldName"
                placeholder="Bearer "
                autocomplete="off"
                [(ngModel)]="integration.productVariantUniqueIdFieldName"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label for="productSyncFrequency">Product sync frequency</label>
              <input
                type="text"
                class="form-control"
                id="productSyncFrequency"
                name="productSyncFrequency"
                placeholder="Bearer "
                autocomplete="off"
                [(ngModel)]="integration.productSyncFrequency"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label for="analyticsUrl">Analytics URL</label>
              <input
                type="text"
                class="form-control"
                id="analyticsUrl"
                name="analyticsUrl"
                placeholder="https://"
                autocomplete="off"
                [(ngModel)]="integration.analyticsUrl"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label for="productIds">Coma separated product IDs</label>
              <input
                type="text"
                class="form-control"
                id="productIds"
                name="productIds"
                placeholder="111,222,333"
                autocomplete="off"
                [(ngModel)]="productIds"
                maxlength="100"
              />
            </div>
            <div class="form-group">
              <label for="headerElements">Coma separated header elements</label>
              <input
                type="text"
                class="form-control"
                id="headerElements"
                name="headerElements"
                placeholder=".header,header,#header"
                autocomplete="off"
                [(ngModel)]="integration.headerElements"
                maxlength="100"
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <fieldset>
            <legend>Feature Flags:</legend>
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enableShoppableVideo"
                name="enableShoppableVideo"
                [(ngModel)]="integration.productFlags.shoppableVideos"
              />
              <label class="custom-control-label" for="enableShoppableVideo"
                >Shoppable Videos</label
              >
            </div>
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enableLiveSession"
                name="enableLiveSession"
                [(ngModel)]="integration.productFlags.liveSessions"
              />
              <label class="custom-control-label" for="enableLiveSession">Live Sessions</label>
            </div>
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enablePolls"
                name="enablePolls"
                [(ngModel)]="integration.productFlags.polls"
              />
              <label class="custom-control-label" for="enablePolls">Polls</label>
            </div>
            <div class="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enableTimelines"
                name="enableTimelines"
                [(ngModel)]="integration.productFlags.timelines"
              />
              <label class="custom-control-label" for="enableTimelines">Timelines</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="enableTalkingPointsAnalysis"
                name="enableTalkingPointsAnalysis"
                [(ngModel)]="enableTalkingPointsAnalysis"
              />
              <label class="custom-control-label" for="enableTalkingPointsAnalysis"
                >Enable Talking Points (Copilot)</label
              >
            </div>
          </fieldset>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="requiresLoginByDefault"
              name="requiresLoginByDefault"
              [(ngModel)]="store.sessionActionsRequireLoginDefault"
            />
            <label class="custom-control-label" for="requiresLoginByDefault"
              >Session actions require login by default</label
            >
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="updateCoriunder"
              name="updateCoriunder"
              [(ngModel)]="updateCoriunder"
            />
            <label class="custom-control-label" for="updateCoriunder"
              >Set Coriunder Keys? (will rewrite current set up for the store)</label
            >
          </div>
        </div>

        <div *ngIf="updateCoriunder" class="form-group">
          <label for="merchantnumber">Merchant Number</label>
          <input
            type="number"
            class="form-control"
            id="merchantnumber"
            name="merchantnumber"
            placeholder="1234567"
            autocomplete="off"
            required
            [(ngModel)]="coriunder.merchantnumber"
          />
        </div>

        <div *ngIf="updateCoriunder" class="form-group">
          <label for="hashkey">Hash Key</label>
          <input
            type="password"
            class="form-control"
            id="hashkey"
            name="hashkey"
            placeholder="**********"
            autocomplete="off"
            required
            [(ngModel)]="coriunder.personalhashkey"
          />
        </div>

        <div class="form-group" *ngIf="showStoreTokenField">
          <label for="utokenl">Store Token*</label>
          <input
            type="text"
            class="form-control"
            id="token"
            name="token"
            placeholder="Store Token"
            autocomplete="off"
            [(ngModel)]="token"
            minlength="3"
            maxlength="100"
          />
          <ng-container *ngIf="{getPassed: isT1CredentialsAreValid$ | async} as valuesObj">
            <span *ngIf="valuesObj.getPassed === null">Checking token...</span>
            <span *ngIf="valuesObj.getPassed === false" class="text-danger">
              Token is invalid {{ errorMessage ? ' - ' + errorMessage : '' }}
            </span>
            <span *ngIf="valuesObj.getPassed === true" class="text-success"> Token is valid </span>
          </ng-container>
        </div>

        @if(this.storeHasLinkedIntegration) {
        <div class="form-group">
          <label for="cronExp">Automatic Sync Schedule (CRON Expression)</label>
          <div id="edit-cron-div">
            <input
              type="text"
              class="form-control"
              id="cronExp"
              name="cronExp"
              placeholder="CRON expression"
              autocomplete="off"
              [(ngModel)]="this.store.cronScheduledSync"
              minlength="3"
              maxlength="100"
              disabled="true"
            />
            <button
              id="edit-cron-button"
              class="btn btn-yellow w-132"
              (click)="openCronExpressionEditModal()"
            >
              Edit
            </button>
          </div>
        </div>
        }

        <div class="form-group">
          <label for="storeType">Allowed domains</label>
          <div class="container allowed-domains-container">
            <table class="table">
              <thead>
                <tr>
                  <th>Address Pattern</th>
                  <th>Created At</th>
                  <th>Enabled</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (item of store.allowedDomains; track trackById; let index = $index) {
                <tr>
                  <td>
                    <input
                      type="text"
                      [(ngModel)]="item.addressPattern"
                      name="addressPattern-{{ index }}"
                      class="form-control"
                      placeholder="Edit address pattern"
                    />
                  </td>
                  <td>{{ formatDate(item.createdAt) }}</td>
                  <td>
                    <input
                      type="checkbox"
                      [(ngModel)]="item.isEnabled"
                      name="isEnabled-{{ index }}"
                    />
                  </td>
                  <td>
                    <button class="btn btn-danger" (click)="removeItem(index)">Remove</button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
            <button class="btn btn-primary mb-3 add-domain-button" (click)="addNewAllowedDomain()">
              Add New Domain
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-yellow w-132"
    (click)="save(storeForm)"
    [disabled]="isSubmitting"
  >
    Save
  </button>
</div>
